export default __webpack_public_path__ + "static/media/chaise.782e12dc.jpg";